"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "casalbore": {
    "5b577c79": [{
      "hkey": "af0a89a7",
      "slug": "casalbore",
      "name": "Casalbore",
      "primary": true,
      "skipSearch": false
    }],
    "fontana-del-casale": [{
      "hkey": "af0a89a7",
      "slug": "casalbore",
      "name": "Casalbore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8f773631": [{
      "hkey": "af0a89a7",
      "slug": "casalbore",
      "name": "Casalbore",
      "primary": true,
      "skipSearch": false
    }],
    "la-guardia": [{
      "hkey": "af0a89a7",
      "slug": "casalbore",
      "name": "Casalbore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1eca69e5": [{
      "hkey": "af0a89a7",
      "slug": "casalbore",
      "name": "Casalbore",
      "primary": true,
      "skipSearch": false
    }],
    "macchia-porcara": [{
      "hkey": "af0a89a7",
      "slug": "casalbore",
      "name": "Casalbore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "21ede0d1": [{
      "hkey": "af0a89a7",
      "slug": "casalbore",
      "name": "Casalbore",
      "primary": true,
      "skipSearch": false
    }],
    "masseria-san-pietro": [{
      "hkey": "af0a89a7",
      "slug": "casalbore",
      "name": "Casalbore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d8176fd1": [{
      "hkey": "af0a89a7",
      "slug": "casalbore",
      "name": "Casalbore",
      "primary": true,
      "skipSearch": false
    }],
    "pietra-piccola": [{
      "hkey": "af0a89a7",
      "slug": "casalbore",
      "name": "Casalbore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c4b1732c": [{
      "hkey": "af0a89a7",
      "slug": "casalbore",
      "name": "Casalbore",
      "primary": true,
      "skipSearch": false
    }],
    "san-michele": [{
      "hkey": "af0a89a7",
      "slug": "casalbore",
      "name": "Casalbore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fb014070": [{
      "hkey": "af0a89a7",
      "slug": "casalbore",
      "name": "Casalbore",
      "primary": true,
      "skipSearch": false
    }],
    "spineto": [{
      "hkey": "af0a89a7",
      "slug": "casalbore",
      "name": "Casalbore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;